import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import CookiesPage from "@/pages/legal/Cookies";

export const Route = createFileRoute("/$lang/cookies")({
  head: ({ params }) => pageHead(params.lang, "cookies"),
  component: CookiesPage,
});
